import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_12: FaireProductEntity = {
  token: "atc_fs_12",
  type: "product",
  name: "Good Morning Beautiful Wipes",
  brandName: "Happy Spritz",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/bab024d6c8bdf44adf9cde8a8fdf3bf5ef087386c597c6666bfe3771b9a89e72.webp",
  priceDollars: 8,
  msrpDollars: 16,
  description: "ATC migration seed product",
  tags: ["beauty", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
